(function () {
    'use strict';

    angular
        .module("skillsApp")
        .controller("AdminSettingsController", AdminSettingsController);

    function AdminSettingsController($q, $translate, config, logger, dataService) {
        var vm = this;

        vm.active = 1;

        $q.all([dataService.getSettingsForAdmin()]).then(response => {
            vm.settings = response[0].data;
        });

        vm.administratorIdentitySelected = administratorIdentitySelected;
        vm.assessorIdentitySelected = assessorIdentitySelected;
        vm.deleteAdministrator = deleteAdministrator;
        vm.deleteReportViewer = deleteReportViewer;
        vm.deleteAssessor = deleteAssessor;
        vm.reportViewerIdentitySelected = reportViewerIdentitySelected;
        vm.saveAllowManageAssignments = saveAllowManageAssignments;
        vm.saveAllowManageExemptions = saveAllowManageExemptions;
        vm.saveAllowManageChildDepartments = saveAllowManageChildDepartments;
        vm.saveAnonymizeReports = saveAnonymizeReports;
        
        vm.setActive = setActive;
        
        function administratorIdentitySelected(identity) {

            if (_.find(vm.settings.admins, { idString: identity.idString })) return;

            dataService.saveAdministrator(identity).then(result => {
                if (result.ok) {
                    logger.success(identity.displayName + ' ' + $translate.instant('added'));
                    vm.settings.admins = result.admins;
                }
            });
        }

        function assessorIdentitySelected(identity) {

            if (_.find(vm.settings.assessorSettings.assessors, { idString: identity.idString })) return;

            dataService.saveAssessor(identity).then(result => {
                if (result.ok) {
                    logger.success(identity.displayName + ' ' + $translate.instant('added'));
                    vm.settings.assessorSettings.assessors = result.assessors;
                }
            });
        }

        function deleteAdministrator(identity) {
            dataService.deleteAdministrator(identity.idString).then(result => {
                if (result.ok) {
                    logger.success(identity.displayName + ' ' + $translate.instant('deleted'));
                    vm.settings.admins = result.admins;
                }
            });
        }

        function deleteAssessor(identity) {
            dataService.deleteAssessor(identity.idString).then(result => {
                if (result.ok) {
                    logger.success(identity.displayName + ' ' + $translate.instant('deleted'));
                    vm.settings.assessorSettings.assessors = result.assessors;
                }
            });
        }

        function deleteReportViewer(identity) {
            dataService.deleteReportViewer(identity.idString).then(result => {
                if (result.ok) {
                    logger.success(identity.displayName + ' ' + $translate.instant('deleted'));
                    vm.settings.reportViewerSettings.reportViewers = result.reportViewers;
                }
            });
        }
        
        function reportViewerIdentitySelected(identity) {

            if (_.find(vm.settings.reportViewerSettings.reportViewers, { idString: identity.idString })) return;

            dataService.saveReportViewer(identity).then(result => {
                if (result.ok) {
                    logger.success(identity.displayName + ' ' + $translate.instant('added'));
                    vm.settings.reportViewerSettings.reportViewers = result.reportViewers;
                }
            });
        }

        function saveAllowManageAssignments() {
            return dataService.saveSetting('managers/allow-manage-assignments', vm.settings.managerSettings.allowManageAssignments).then(result => {
                logger.success($translate.instant('successfully_saved'));
            });
        }

        function saveAllowManageExemptions() {
            return dataService.saveSetting('assessors/allow-manage-exemptions', vm.settings.assessorSettings.allowManageExemptions).then(result => {
                logger.success($translate.instant('successfully_saved'));
            });
        }

        function saveAllowManageChildDepartments() {
            return dataService.saveSetting('managers/allow-manage-child-departments', vm.settings.managerSettings.allowManageChildDepartments).then(result => {
                logger.success($translate.instant('successfully_saved'));
            });
        }

        function saveAnonymizeReports() {
            return dataService.saveSetting('anonymize-reports', vm.settings.reportViewerSettings.anonymizeReports).then(result => {
                logger.success($translate.instant('successfully_saved'));
            });
        }
        
        function setActive(idx) {
            vm.active = idx;
        }
    }
})();